import mobileSales from "./mobileSales";

export default function mobileMaster() {
    return [
        
    ];
  }
  